export const JWT_KEY = "jwtToken";

export const PROFILE_PICTURE = "userProfilePicture";

export const HAS_AGENT_GENERATE_DOCUMENT_ACCESS = "HasAgentGenerateDocumentAccess";
